import React from 'react';
import { CloudSnow, Wind, Thermometer, Droplets } from 'lucide-react';
export function WeatherOverview() {
  return <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-698">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-699">
        <div className="flex items-center justify-between" data-id="element-700">
          <div data-id="element-701">
            <p className="text-sm text-gray-600" data-id="element-702">Température</p>
            <p className="text-3xl font-bold text-gray-900 mt-1" data-id="element-703">-8°C</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-704">Ressentie: -12°C</p>
          </div>
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-705">
            <Thermometer className="w-6 h-6 text-blue-600" data-id="element-706" />
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-707">
        <div className="flex items-center justify-between" data-id="element-708">
          <div data-id="element-709">
            <p className="text-sm text-gray-600" data-id="element-710">Précipitations</p>
            <p className="text-3xl font-bold text-gray-900 mt-1" data-id="element-711">85%</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-712">Neige prévue</p>
          </div>
          <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center" data-id="element-713">
            <CloudSnow className="w-6 h-6 text-indigo-600" data-id="element-714" />
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-715">
        <div className="flex items-center justify-between" data-id="element-716">
          <div data-id="element-717">
            <p className="text-sm text-gray-600" data-id="element-718">Vent</p>
            <p className="text-3xl font-bold text-gray-900 mt-1" data-id="element-719">25 km/h</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-720">Nord-Est</p>
          </div>
          <div className="w-12 h-12 bg-cyan-100 rounded-lg flex items-center justify-center" data-id="element-721">
            <Wind className="w-6 h-6 text-cyan-600" data-id="element-722" />
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-723">
        <div className="flex items-center justify-between" data-id="element-724">
          <div data-id="element-725">
            <p className="text-sm text-gray-600" data-id="element-726">Humidité</p>
            <p className="text-3xl font-bold text-gray-900 mt-1" data-id="element-727">78%</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-728">Point de rosée: -10°C</p>
          </div>
          <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center" data-id="element-729">
            <Droplets className="w-6 h-6 text-teal-600" data-id="element-730" />
          </div>
        </div>
      </div>
    </div>;
}